/// <reference path="blocks.logger.module.ts"/>

module Blocks {
    export interface IException extends ng.IModule { }

    export class Exception {
        static moduleId: string = 'blocks.exception';
    }

    // Create the module and define its dependencies.
    export var exception: IException = angular.module(Exception.moduleId, [
        Logger.moduleId
    ]);

    // Execute bootstrapping code and any dependencies.
    exception.run([() => { }]);
}
